import { Box } from "@mui/material";
import { LegalDocumentViewer } from "../../components/legal-document-viewer";
import { termsOfUse } from "./content";

export const TermsOfUsePage = () => {
  return (
    <Box className="terms-of-use-page page">
      <LegalDocumentViewer documentContent={termsOfUse} />
    </Box>
  );
};
